/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Maria_Ward_Schule_Aschaffenburg5Inputs */

const en__field__enum_schoolname_maria_ward_schule_aschaffenburg5 = /** @type {(inputs: _Field__Enum_Schoolname_Maria_Ward_Schule_Aschaffenburg5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aschaffenburg`)
};

const de__field__enum_schoolname_maria_ward_schule_aschaffenburg5 = /** @type {(inputs: _Field__Enum_Schoolname_Maria_Ward_Schule_Aschaffenburg5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maria-Ward-Schule`)
};

/**
* | output |
* | --- |
* | "Aschaffenburg" |
*
* @param {_Field__Enum_Schoolname_Maria_Ward_Schule_Aschaffenburg5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_maria_ward_schule_aschaffenburg5 = /** @type {((inputs?: _Field__Enum_Schoolname_Maria_Ward_Schule_Aschaffenburg5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Maria_Ward_Schule_Aschaffenburg5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_maria_ward_schule_aschaffenburg5(inputs)
	return de__field__enum_schoolname_maria_ward_schule_aschaffenburg5(inputs)
});
export { _field__enum_schoolname_maria_ward_schule_aschaffenburg5 as "_field__enum_schoolName_Maria_Ward_Schule_Aschaffenburg" }